import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import React from 'react';

const PREFIX = 'TimeWidget';

const classes = {
  bgHover: `${PREFIX}-bgHover`
};

const Root = styled('div')(({ theme }) => ({
  [`& .${classes.bgHover}`]: {
    '&:hover': {
      background: theme.palette.primary.light
    }
  }
}));

const TimeWidget = ({ setValue, value, valueError, field }: any) => {
  const onChangeHandler = (event: any) => {
    setValue(event.target.value.replace(/^\s+/g, ''));
  };

  return (
    <Root>
      <TextField
        inputProps={{ 'data-testid': `querybuilder-time-widget`, className: classes.bgHover }}
        type="time"
        error={valueError?.length > 0}
        helperText={valueError}
        variant="outlined"
        required
        id={field}
        name={field}
        className={classes.bgHover}
        placeholder=""
        onChange={onChangeHandler}
        value={value || ''}
      />
    </Root>
  );
};

export default TimeWidget;
